var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 9.55811C19 4.3114 14.7467 0.0581055 9.5 0.0581055C4.25329 0.0581055 0 4.3114 0 9.55811C0 14.2998 3.47399 18.23 8.01562 18.9427V12.3042H5.60352V9.55811H8.01562V7.46514C8.01562 5.0842 9.43395 3.76904 11.6039 3.76904C12.643 3.76904 13.7305 3.95459 13.7305 3.95459V6.29248H12.5326C11.3525 6.29248 10.9844 7.02483 10.9844 7.77685V9.55811H13.6191L13.1979 12.3042H10.9844V18.9427C15.526 18.23 19 14.2998 19 9.55811Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
